import baseApplicationItem from './baseApplicationItem'
import {merge} from 'lodash'

var module = {
  endpoint: 'admin/catalog/product/pricelist'
  // getCurrencies
  // getVats
}

export default merge(module, baseApplicationItem)



// WEBPACK FOOTER //
// ./src/application/pricelist.js